import React, { forwardRef, useState } from 'react';
import { UsageMetricsChartRef } from 'utils/types';
// import BackupsChart from './Charts/BackupsChart';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Form, Select, Tooltip, Typography } from 'antd';
import ClassAChart from './Charts/ClassAChart';
import ClassBChart from './Charts/ClassBChart';
import DownloadsChart from './Charts/DownloadsChart';
import UploadsChart from './Charts/UploadsChart';

const { Title } = Typography;
const { Option } = Select;

interface UsageMetricsChartProps {
  buckets: any[]; // Replace `any[]` with the correct type if you have one
  start: any;
  end: any;
}

const UsageMetricsChart = forwardRef<UsageMetricsChartRef, UsageMetricsChartProps>(({ buckets, start, end }, ref) => {
  const [selectedChart, setSelectedChart] = useState<string>('classA');
  const chartOptions = [
    {
      value: 'classA',
      label: 'Class-A',
      tooltip: 'Class-A represents Write-only access operations performed on your bucket.',
    },
    {
      value: 'classB',
      label: 'Class-B',
      tooltip: 'Class-B represents read-only access operations performed on your bucket.',
    },
    {
      value: 'downloads',
      label: 'Downloads (Size)',
    },
    {
      value: 'uploads',
      label: 'Uploads (Size)',
    },
  ];
  return (
    <div>
      <div className="ChartFilter">
        <Title level={4} className="ant-typography ChartFilter__title truncate">
          Usage Metrics
        </Title>
        <Form layout="vertical">
          <Form.Item label="Select Chart">
            <Select style={{ width: 200 }} value={selectedChart} onChange={(value) => setSelectedChart(value)}>
              {chartOptions.map(({ value, label, tooltip }) => (
                <Option value={value} key={value}>
                  <span
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}
                  >
                    <span>{label}</span>
                    {tooltip && (
                      <Tooltip title={tooltip} placement="right">
                        <InfoCircleOutlined style={{ color: '#b0b0b0', marginLeft: 8 }} />
                      </Tooltip>
                    )}
                  </span>
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </div>

      {/* Conditionally render chart based on selected value */}
      {selectedChart === 'classA' && <ClassAChart ref={ref} buckets={buckets} start={start} end={end} />}
      {selectedChart === 'classB' && <ClassBChart ref={ref} buckets={buckets} start={start} end={end} />}
      {selectedChart === 'downloads' && <DownloadsChart ref={ref} buckets={buckets} start={start} end={end} />}
      {selectedChart === 'uploads' && <UploadsChart ref={ref} buckets={buckets} start={start} end={end} />}
      {/* {selectedChart === 'backups' && <BackupsChart />} */}
    </div>
  );
});

export default UsageMetricsChart;
export { ClassAChart, ClassBChart, DownloadsChart, UploadsChart };
